// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const groupAccessRequestCreateSchema = z.object({
  "group_id": z.string().uuid(),
  "application_id": z.string().uuid(),
  "reason": z.string().min(10).max(4000),
  "duration_minutes": z.number().int().min(15).max(43200),
  "type": z.enum(["time_bound"])
}).strict();

export const adminAccessRequestSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "user_id": z.string().uuid().nullable().optional(),
  "group_id": z.string().uuid().optional(),
  "group_name": z.string().optional(),
  "membership_mode": z.enum(["dynamic"]).optional(),
  "current_member_count": z.number().int().min(0).optional(),
  "application_id": z.string().uuid(),
  "reason": z.string(),
  "duration_minutes": z.number().int(),
  "status": z.string(),
  "requested_at": z.string()
});
